import bgDefault from'./../img/bg.png';
import cyoa from'./../img/cover-cyoa.png';
import site from'./../img/cover-sitedev.png';
import spec from'./../img/cover-spec.png';
import mend from'./../img/cover-mend.png';
import esports from'./../img/cover-esports.png';
import artwork from'./../img/cover-art.png';

var colorCyoa = getComputedStyle(document.documentElement).getPropertyValue('--color-cyoa');
var colorSite = getComputedStyle(document.documentElement).getPropertyValue('--color-site');
var colorSpec = getComputedStyle(document.documentElement).getPropertyValue('--color-spec');
var colorMend = getComputedStyle(document.documentElement).getPropertyValue('--color-mend');
var colorEsports = getComputedStyle(document.documentElement).getPropertyValue('--color-esports');
var colorArt = getComputedStyle(document.documentElement).getPropertyValue('--color-art');
var secondary = getComputedStyle(document.documentElement).getPropertyValue('--text-light-secondary');

function defaultState() {
    $(".bg").fadeTo(30, 0.5);
    $(".bg").attr("src", bgDefault);
    $(".tag").css("color", secondary);
}

$(document).ready(function() {
    
    defaultState();

    // hover effects for index divs
    $('.work-child').hover(
        function () {
            $('.work-child').not(this).fadeTo(50, 0.25);
            $(".bg").fadeTo(30, 1);
        },
        function () {
            $('.work-child').fadeTo(50, 1);
    });

    // hovering projects to change background

    $("#cyoa").hover(
        function() {
            $(".bg").attr("src", cyoa);
            $("#cyoa .tag").css("color", colorCyoa);
        },
        function() {
            defaultState();
        }
    );

    $("#sitedev").hover(
        function() {
            $(".bg").attr("src", site);
            $("#sitedev .tag").css("color", colorSite);
        },
        function() {
            defaultState();
        }
    );

    $("#spec").hover(
        function() {
            $(".bg").attr("src", spec);
            $("#spec .tag").css("color", colorSpec);
        },
        function() {
            defaultState();
        }
    );

    $("#mend").hover(
        function() {
            $(".bg").attr("src", mend);
            $("#mend .tag").css("color", colorMend);
        },
        function() {
            defaultState();
        }
    );

    $("#esports").hover(
        function() {
            $(".bg").attr("src", esports);
            $("#esports .tag").css("color", colorEsports);
        },
        function() {
            defaultState();
        }
    );

    $("#artwork").hover(
        function() {
            $(".bg").attr("src", artwork);
            $("#artwork .tag").css("color", colorArt);
        },
        function() {
            defaultState();
        }
    );

});